import React, { useEffect, useState } from "react";
import { History } from "./History";
import { Navigation } from "./Navigation";
import { NewChat } from "./NewChat";
import styles from "./style.scss";
import { useAiResearch } from "./hooks";
import { useLocation } from "react-router";
import cn from "classnames";
import { trackAction } from "utils/helper/analytics";

// AIリサーチ画面コンポーネント
export const AiResearch: React.FC = () => {
  const [isNavOpen, setIsNavOpen] = useState(true);
  const [isShowFooter, setIsShowFooter] = useState<boolean>(false);

  const location = useLocation();
  const {
    result,
    reference,
    type,
    isLoading,
    isReferenceLoading,
    isOpen,
    history,
    setType,
    onShowHistory,
    onShowReference,
    clearReference,
    onSendQuestion,
    onDownload,
    onClickNewChat,
    onClose,
    onCopy
  } = useAiResearch();

  const searchParams = new URLSearchParams(location.search);
  const selectedTalkId = searchParams.get("talkId");

  useEffect(() => {
    // ウィンドウが 1383 より小さい場合は、左側のメニューを折りたたむ
    const handleResize = () => {
      if (window.innerWidth < 1383) {
        setIsNavOpen(false);
      } else {
        setIsNavOpen(true);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // フッターが表示されているかの判定。フッターが表示している間はナビゲーションの高さを縮める
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      setIsShowFooter(!!entries[0].isIntersecting);
    });

    const footer = document.getElementById("footer");

    if (!footer) return;

    observer.observe(footer);
  }, []);

  // 質問送信時の処理
  const handleSubmit = (text: string) => {
    if (!text) return;
    if (type === "newChat") {
      setType("history");
    }

    onSendQuestion(text);
  };

  // キャンセル時の処理
  const handleCancel = () => {
    onClose();
  };

  // コピー時の処理
  const handleCopy = ({ chatIndex }: { chatIndex: number }) => {
    onCopy({ chatIndex });
  };

  return (
    <div className={cn(styles.container, !isNavOpen && styles.navClosed)}>
      <nav
        className={cn(
          styles.navigation,
          !isNavOpen && styles.navClosed,
          isShowFooter && styles.showFooter
        )}
      >
        <Navigation
          history={history}
          selectedId={selectedTalkId}
          onClickNewChat={() => {
            trackAction("clickNewAiChat");
            onClickNewChat();
          }}
          onClickHistoryItem={talkId => {
            trackAction("clickHistoryAiChat");
            onShowHistory(talkId);
          }}
          isOpen={isNavOpen}
          onOpenChange={setIsNavOpen}
        />
      </nav>
      <div className={styles.content}>
        {type === "newChat" ? (
          <NewChat handleSubmit={handleSubmit} onCancel={handleCancel} />
        ) : (
          <History
            chat={result}
            reference={reference}
            handleSubmit={handleSubmit}
            handleCopy={handleCopy}
            handleDownload={onDownload}
            isLoading={isLoading}
            isReferenceLoading={isReferenceLoading}
            isOpen={isOpen}
            onCancel={handleCancel}
            onShowReference={onShowReference}
            clearReference={clearReference}
          />
        )}
      </div>
    </div>
  );
};
